<div>
	<label (click)="isCollapsed = !isCollapsed"
		   [attr.aria-expanded]="!isCollapsed" aria-controls="collapseTable">
		<i [ngClass]="isCollapsed?'fa fa-caret-right fa-2':'fa fa-caret-down fa-2'" aria-hidden="true"></i>
		<strong class="d-inline-flex p-2">{{title}}</strong>
	</label>
	<div id="collapseTable" [ngbCollapse]="isCollapsed">
		<span *ngIf="!hideAddAndRemove" class="btn btn-info float-end" data-test="addEntryDetailsButton"
			  style="margin-bottom: 10px;" (click)="openSelectVariable()">{{'variable-container.add.button' | translate}}</span>
		<div>
			<table class="table table-striped table-bordered table-curved" data-test="entryDetailsTable">
				<thead>
				<tr>
					<th style="width: 30px;">
						<a *ngIf="existsVariableDeletables()">
							<input type="checkbox" class="form-check-input" [checked]="isAllSelected()" (click)="onSelectAll()"/>
						</a>
					</th>
					<th style="width: auto; min-width: 150px;">{{'variable-container.column.name' | translate}}</th>
					<th style="width: auto">{{'variable-container.column.description' | translate}}</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let variable of variables; index as index">
					<td>
						<input [hidden]="variable.metadata && !variable.metadata.deletable" type="checkbox" class="form-check-input" [checked]="isSelected(variable)" (click)="toggleSelect(index, variable, true)">
					</td>
					<td style="width: auto; min-width: 150px;">
						<a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
						   [queryParams]="{ variableId: variable.id }">{{variable.alias ? variable.alias : variable.name}}</a>
					</td>
					<td style="width: auto">{{variable.definition ? variable.definition : variable.description}}</td>
				</tr>
				<tr *ngIf="variables.length === 0">
					<td>&nbsp;</td>
					<td>&nbsp;</td>
					<td>&nbsp;</td>
				</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="existsVariableDeletables() && !hideAddAndRemove">
			<a href style="padding-left: 15px;" (click)="remove($event)">{{ 'variable-container.remove.link' | translate}}</a>
		</div>
	</div>
</div>
